import { dataFetcher } from 'core/services/requestHandler';   

const getIssuesByProperty = async (data = {}, config = {}) => {
  return dataFetcher('issues/getIssuesByPropertyId', data, {...config});
};

const getIssuesByDate = async (data = {}, config = {}) => {
  return dataFetcher('issues/getIssuesByDate', data, {...config});
};

const resolveIssue = async (data = {}, config = {}) => {
  return dataFetcher('issues/resolveIssue', data, {...config});
};

const addConversation = async (data = {}, config = {}, issueId) => {
  return dataFetcher(`issues/${issueId}/addConversation`, data, {method: 'POST', ...config});
};


export { getIssuesByProperty, getIssuesByDate, resolveIssue, addConversation };
